import {
    Subject
} from 'one-state-subject/src/Subject';
import { diff, format, formatIso } from 'one-util-date';
import {
    EmergencyDetails
} from 'one-state-subject';
import {
    EmployerDetails
} from 'one-state-subject';

// ADPAC-316
function sortFunction(a: Subject, b: Subject) {
    const nameA = a.lastname.toLowerCase();
    const nameB = b.lastname.toLowerCase();
    return (nameA > nameB) ? 1 : -1;

}
const checkAge = (dob: any) => {
    let age = "";
    if (dob !== undefined && dob !== null && dob !== "") {
        age = diff(dob).toString();
    }
    return age;
}

export const formatPhoneNumber = (phoneNumberString: any) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length == 10) {
        return '(' + cleaned.substring(0, 3) + ') ' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, 10);
    }
    return "";
}
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * upcoming Appointments Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: Subject[] = [];

    let subjectresult: any = {
        subjectdata: result,
        error: undefined

    }
    const { log, settings: { uisettings: { dateformat, prescription_mrn: { mrn_value },display_patientid } } } = context;
    log.debug("one-athena", "transformation entered", response);

    if (response && (response.status >= 400 || response.type == "error")) {
        subjectresult.error = response;
    }
    //ADPAC-348
    else if (response && response?.length > 0) {
        const rs = response;
        rs.map((ele: any) => {
            let source: Subject = {
                initials: "",
                id: "",
                middlename: "",
                mrn: "",
                dob: "",
                gender: "",
                age: "",
                contact: "",
                contact_formatted: "",
                address: "",
                lastname: "",
                firstname: "",
                name: "",
                preferredName: [],
                race: "",
                email: "",
                ssn: "",
                zipcode: "",
                providerid: "",
                displayid:"",
                displayidtype:"",
                prescriptionMRNData: "",
                emergencycontact: [],
                employmentinfo: [],
                departmentid:""
            
            }
            source.initials = ele.lastname?.charAt(0) + ele.firstname?.charAt(0)
            source.firstname = ele.firstname;
            source.lastname = ele.lastname;
            source.name = ele.firstname + ' ' + ele.lastname;
            source.preferredName = ele.PreferredName;
            source.departmentid=ele.currentdepartmentid
            source.providerid=ele.providergroupid
            source.dob = ele.dob ? formatIso(ele.dob, dateformat) : "";
            const age = checkAge(ele.dob);
            source.age = age ? age : "";
            //source.age = age ? age + " year old " + ele?.Sex : "";
            source.gender = ele.sex;
            source.race = ele.race;
            source.ssn = ele.ssn;
            source.countryid = ele.countryid;
            source.homephone = ele.homephone ? ele.homephone  : "";
            source.mobilephone = ele.mobilephone;
            source.workphone = ele.workphone;
            source.address = ele.address1;
            source.localpatientid = ele.localpatientid;
            source.mrn = ele.localpatientid;
            source.id = ele.localpatientid;
            source.displayidtype = display_patientid;
            source.displayid = ele.localpatientid;
            let emergencydata: EmergencyDetails[] = [];
            let employerinfo: EmployerDetails[] = [];
            if (ele.EmergencyContacts) {
                ele.EmergencyContacts.map((emerge: any) => {
                    let info = {
                        emergename: emerge?.Name ? emerge.Name : "",
                        contactrelation: emerge?.Relation ? emerge.Relation : "",
                        contactnumber: ""
                    }
                    emergencydata.push(info)
                    emerge?.PhoneNumbers.forEach((contactdata: any) => {
                        if (contactdata?.Type === "Home Phone") {
                            info.contactnumber = contactdata.Number
                        }
                    });
                })
            }
            if (ele.EmploymentInformation) {
                ele.EmploymentInformation.map((emerge: any) => {
                    let info = {
                        employername: emerge?.EmployerName ? emerge.EmployerName : "",
                        occupation: emerge?.Occupation ? emerge.Occupation : "",
                        contactnumber: ""
                    }
                    employerinfo.push(info)
                    emerge?.PhoneNumbers.forEach((contactdata: any) => {
                        if (contactdata) {
                            info.contactnumber = contactdata.Number
                        }
                    });
                })
            }
            source.contact = ele.homephone ? ele.homephone  : "" ;
            source.contact_formatted = ele.homephone ? ele.homephone  : "";
            source.email = ele.email;
            source.emergencycontact = emergencydata;
            source.employmentinfo = employerinfo;
            result.push(source);
        })
    }
    // ADPAC-316
    result.sort(sortFunction);
    subjectresult.subjectdata = result;
    return subjectresult;
}



